/* UPS Solutions Builder prototype (RD.03, Claude 2026-09-27).
   Reads assets/upsb-builder-index.json (tools/builder_index/build_builder_index.py). No store writes except the
   buyer's own cart. Rules: FIXED-RULES.md, DATA-CONTRACT.md
   (unknown facts show "to confirm" and sort after known ones; never invent a plug, a card or a runtime). */
(function () {
  'use strict';

  var XPC = { 'xtreme power conversion': 1, 'xpc': 1 };
  // These exact sold bundle SKUs have no accepted included-versus-extra component contract yet.
  // Keep their identity for technical quotes without treating the bare-UPS pack chart as a bundle chart.
  var P91_BUNDLE_REVIEW = {
    'xpc-p91-5kb': 1, 'xpc-p91-5kb1': 1, 'xpc-p91-5kb2': 1, 'xpc-p91-5kb3': 1,
    'xpc-p91-5ktb': 1, 'xpc-p91-5ktb2': 1, 'xpc-p91-5ktb3': 1, 'xpc-p91-5ktb4': 1,
    'xpc-p91-6ktb': 1, 'xpc-p91-6ktb2': 1, 'xpc-p91-6ktb3': 1, 'xpc-p91-6ktb4': 1,
    'xpc-p91-10ktb': 1, 'xpc-p91-10ktb1': 1, 'xpc-p91-10ktb2': 1
  };
  // DB.04 v2 is an exact 22-model INPUT source scope. These handles fail closed
  // when the sidecar is missing; their legacy scalar volt field is comparison only.
  var TYPED_INPUT_HANDLES = {
    'xpc-a60-550': 1, 'xpc-a60-850': 1, 'xpc-j90-1-5klid': 1,
    'xpc-p80g-3000': 1, 'xpc-p80g-5000': 1,
    'xpc-p91-1-5kli': 1, 'xpc-p91-1000': 1, 'xpc-p91-1500': 1,
    'xpc-p91-2000': 1, 'xpc-p91-2kli': 1, 'xpc-p91-3000': 1,
    'xpc-p91-3kli': 1, 'xpc-p91c-1000': 1, 'xpc-p91g-1-5kli': 1,
    'xpc-p91g-1500': 1, 'xpc-p91g-2000': 1, 'xpc-p91g-3000': 1,
    'xpc-p91g-3kli': 1, 'xpc-t91-2000': 1, 'xpc-t91-2000v2': 1,
    'xpc-t91-3000': 1, 'xpc-t91i-3000': 1
  };
  var TYPED_INPUT_BRIDGE_SHA = 'ba1be92be9dca3a82161fa0f616460b4a6d63ff2b7486ce64d30f1d237d612b1';
  var TYPED_INPUT_SOURCE_SHA = '5aaee04674b92e9d55aefd8d14cde0e0a860e9c183e9107e827aacf83091eae2';
  // GS17: output connection is a typed fact, separate from the receptacle
  // count/string. Never turn a hardwired terminal block into a socket.
  var OUTPUT_CONNECTION_SOURCE_SHA = '54f73719b06ee703d4d0208e309c144778a036cc98717d803725f31a61f72085';
  var OUTPUT_CONNECTION_HANDLES = {
    'xpc-tx91-3-8k': 'hardwired_terminal_blocks',
    'xpc-tx91-5k': 'hardwired_terminal_blocks',
    'xpc-tx91-6k': 'hardwired_terminal_blocks',
    'xpc-tx91-10k': 'hardwired_terminal_blocks',
    'xpc-tx91l-3-8k': 'hardwired_terminal_blocks',
    'xpc-tx91l-5k': 'hardwired_terminal_blocks',
    'xpc-tx91l-6k': 'hardwired_terminal_blocks',
    'xpc-tx91l-10k': 'hardwired_terminal_blocks',
    'ita2-08krt208c': 'hardwired_standard_optional_pod',
    'ita2-10krt208c': 'hardwired_standard_optional_pod'
  };
  var OUTPUT_CONNECTION_MODELS = {
    'xpc-tx91-3-8k': 'TX91-3.8K', 'xpc-tx91-5k': 'TX91-5K',
    'xpc-tx91-6k': 'TX91-6K', 'xpc-tx91-10k': 'TX91-10K',
    'xpc-tx91l-3-8k': 'TX91L-3.8K', 'xpc-tx91l-5k': 'TX91L-5K',
    'xpc-tx91l-6k': 'TX91L-6K', 'xpc-tx91l-10k': 'TX91L-10K',
    'ita2-08krt208c': 'ITA2-08KRT208C', 'ita2-10krt208c': 'ITA2-10KRT208C'
  };
  var OUTPUT_CONNECTION_EVIDENCE = {
    tx91: { url: 'https://xpcc.com/wp-content/uploads/TX91-3.8-10-flyer.pdf',
      sha256: 'bb21ac57b50aba864fce7e10ae1b06e8e159217a74af0006025e70b6c0759758',
      page: '2', raw: 'Input/output Terminal blocks or opti onal PDU' },
    tx91l: { url: 'https://xpcc.com/wp-content/uploads/TX91L-flyer.pdf',
      sha256: '6d0c5f13739f0859d2abaeda0351260842b87f1e4b818daca046a9a420c086b5',
      page: '2', raw: 'Input/output Terminal blocks or opti onal PDU' },
    ita2: { url: 'https://www.vertiv.com/4acbb9/globalassets/products/critical-power/uninterruptible-power-supplies-ups/liebert-ita2-ups-3-phase-208v/vertiv-liebert-ita2-three-phase-ups-vrla-li-ion-br-en-na-sl-26270-web.pdf',
      sha256: '467e7d864494096b11862006e24f7aeb0062fbf9e30b6028cb601d84c33d596b',
      page: '11', raw: 'Hardwired' }
  };
  function validOutputConnections(index) {
    var overlay = index && index.output_connection_v1;
    if (!overlay || overlay.schema !== 'builder-output-connection/v1' ||
        overlay.source_sidecar_sha256 !== OUTPUT_CONNECTION_SOURCE_SHA ||
        !overlay.records || Object.keys(overlay.records).length !== 10 ||
        !Array.isArray(index.fields) || !Array.isArray(index.u)) return false;
    var hcol = index.fields.indexOf('h'), rcol = index.fields.indexOf('rec');
    if (hcol < 0 || rcol < 0) return false;
    var counts = {};
    index.u.forEach(function (row) {
      if (OUTPUT_CONNECTION_HANDLES[row[hcol]]) counts[row[hcol]] = (counts[row[hcol]] || 0) + 1;
    });
    return Object.keys(OUTPUT_CONNECTION_HANDLES).every(function (h) {
      var record = overlay.records[h], source = record && record.source;
      var family = h.indexOf('xpc-tx91l-') === 0 ? 'tx91l' :
        h.indexOf('xpc-tx91-') === 0 ? 'tx91' : 'ita2';
      var evidence = OUTPUT_CONNECTION_EVIDENCE[family];
      return counts[h] === 1 && !!record && record.kind === OUTPUT_CONNECTION_HANDLES[h] &&
        record.model === OUTPUT_CONNECTION_MODELS[h] && record.distribution ===
          (record.kind === 'hardwired_terminal_blocks' ? 'optional_pdu' : 'integrated_pod_option') &&
        source && source.url === evidence.url && source.sha256 === evidence.sha256 &&
        source.page === evidence.page && source.raw === evidence.raw;
    }) && Object.keys(overlay.records).every(function (h) { return !!OUTPUT_CONNECTION_HANDLES[h]; });
  }
  var MAX_PACKS = 8;             // external packs a buyer can add (XPC publishes tables to 8); more goes through a quote
  // DB.18's communication-card kind includes relay and serial Modbus cards. Only these reviewed
  // Ethernet/Web/SNMP cards satisfy a buyer's network-card requirement. New cards need evidence first.
  var NETWORK_CARDS = {
    'apc-ap9640': 1, 'apc-ap9641': 1, 'apc-ap9643': 1, 'cyberpower-rmcard205': 1,
    'eaton-modbus-ms': 1, 'eaton-network-m3': 1, 'tripp-lite-webcardlxe': 1,
    'vertiv-rdu120': 1, 'xpc-snmp-j60': 1, 'xpc-snmp-usb': 1,
    'xpc-snmp-2pv3': 1
  };
  // OEM pricebook P80/P91 connectivity sections and exact-model flyers support
  // these four optional SNMP-2PV3 pairings. This does not establish measured
  // watt telemetry, shutdown software, or an installed/working device.
  var SNMP_2PV3_MODELS = {
    'xpc-p80-1500': 'P80-1500', 'xpc-p80-3000v2': 'P80-3000V2',
    'xpc-p91-1500': 'P91-1500', 'xpc-p91-3000': 'P91-3000'
  };
  var SNMP_2PV3_TOWER_ENCLOSURES = Object.keys(SNMP_2PV3_MODELS);
  var P80_TOWER_PACK_PAIRS = {
    'xpc-p90-bp48': 'xpc-p80-1500',
    'xpc-p90-bp72': 'xpc-p80-3000v2'
  };
  // Manufacturer sources for the optional SNMP-2PV3 card (sold separately), read 2026-09-29:
  // xpcc.com/products/snmp card table "SNMP-2PV3 90000675: J90, P80 (g), P91 (g, Li), T91 100-3000 VA, TX91 (L)";
  // XPC USA pricebook 2026-02-01 p.13 "J90i Connectivity" and p.24 "T91 Connectivity" (T91 section incl. T91i).
  // Exact store handles only. Kept apart from SNMP_2PV3_MODELS, which also drives the tower enclosure rules.
  var SNMP_2PV3_GUIDE_MODELS = {
    'xpc-j90-1-5klid': 1, 'xpc-j90-1klid': 1, 'xpc-j90-2klid': 1, 'xpc-j90-3klid': 1,
    'xpc-j90i-2klid': 1, 'xpc-j90i-3klid': 1, 'xpc-p80g-3000': 1, 'xpc-p80g-5000': 1,
    'xpc-p80g-5ktb': 1, 'xpc-p91-1-5kli': 1, 'xpc-p91-10k': 1, 'xpc-p91-2kli': 1,
    'xpc-p91-3kli': 1, 'xpc-p91-5k': 1, 'xpc-p91-6k': 1, 'xpc-p91g-1-5kli': 1, 'xpc-p91g-2kli': 1,
    'xpc-p91g-3kli': 1, 'xpc-t91-1000': 1, 'xpc-t91-1500': 1, 'xpc-t91-2000': 1,
    'xpc-t91-2000v2': 1, 'xpc-t91-3000': 1, 'xpc-t91-700': 1, 'xpc-t91i-2000': 1,
    'xpc-t91i-3000': 1, 'xpc-tx91-10k': 1, 'xpc-tx91-3-8k': 1, 'xpc-tx91-5k': 1, 'xpc-tx91-6k': 1,
    'xpc-tx91l-10k': 1, 'xpc-tx91l-3-8k': 1, 'xpc-tx91l-5k': 1, 'xpc-tx91l-6k': 1
  };
  function reviewedSnmpPair(u) {
    if (!u || !XPC[String(u.v || '').toLowerCase()]) return false;
    if (SNMP_2PV3_GUIDE_MODELS[u.h] === 1) return true;
    var model = SNMP_2PV3_MODELS[u.h];
    if (!model) return false;
    return new RegExp('(^|[^A-Z0-9])' + model + '($|[^A-Z0-9])', 'i').test(u.t || '');
  }
  // DB.22 proves the two XPC rail kits. Eaton 744-A4072 is still unknown in
  // DB.22, so its store rail label must not make it an automatic rack choice.
  var RACK_RAILS = { 'xpc-p90-rail': 1, 'xpc-xpc-2prail': 1 };
  // Eaton identifies EBP-1608-L as an internal replacement battery, not the external
  // 9PXEBM48RT-L. The store index currently labels it as an EBM; keep it out of
  // external-pack choices until the catalogue and index inputs are corrected.
  // https://www.eaton.com/us/en-us/skuPage.9PX1500RT-L.html
  var INTERNAL_REPLACEMENT_BATTERIES = { 'eaton-ebp-1608-l': 1 };
  // The exact RTN-L UPS includes NETWORK-M3, although its current store metafield
  // says the card is absent. Do not offer or charge for a second card by default.
  // https://www.eaton.com/us/en-us/skuPage.9PX1500RTN-L.html
  var OEM_INCLUDED_CARD = { '9px1500rtn-l': 1 };
  function eligibleAccessory(a, t, u) {
    return a && a[2] === t && (t !== 'c' || NETWORK_CARDS[a[0]] === 1) &&
      (a[0] !== 'xpc-snmp-2pv3' || reviewedSnmpPair(u)) &&
      (t !== 'r' || RACK_RAILS[a[0]] === 1) &&
      (t !== 'e' || INTERNAL_REPLACEMENT_BATTERIES[a[0]] !== 1);
  }
  // Wall receptacle -> the unit input plugs it accepts (NEMA configuration rules).
  var OUTLET_ACCEPTS = {
    '5-15R': ['5-15P'],
    '5-20R': ['5-15P', '5-20P'],
    'L5-20R': ['L5-20P'],
    'L5-30R': ['L5-30P'],
    'L6-20R': ['L6-20P'],
    'L6-30R': ['L6-30P'],
    'HW': ['HARDWIRE', 'HARDWIRED', 'HARD WIRE', 'TERMINAL']
  };

  function normPlug(p) {
    return String(p || '').toUpperCase().replace('NEMA', '').replace(/\s+/g, ' ').trim();
  }

  function plugFits(outlet, plug) {
    if (!outlet || outlet === 'unknown') return 'yes';
    var p = normPlug(plug);
    if (!p) return 'confirm';
    var ok = OUTLET_ACCEPTS[outlet] || [];
    for (var i = 0; i < ok.length; i++) {
      // whole plug code only: "5-20P" must not match inside "L5-20P" (a twist-lock plug does not fit a 5-20R outlet)
      if (new RegExp('(^|[^A-Z0-9])' + ok[i].replace(/-/g, '\\-') + '($|[^A-Z0-9])').test(p)) return 'yes';
    }
    return 'no';
  }

  function voltFits(power, code) {
    if (!power || power === 'unknown') return 'yes';
    if (!code) return 'confirm';
    if (power === '120') return (code === '120' || code === '120/208') ? 'yes' : 'no';
    if (power === '208-240') return (code === '208' || code === '240' || code === '208/240' || code === '120/208') ? 'yes' : 'no';
    if (power === '230') return (code === '240' || code === '208/240') ? 'confirm' : 'no';
    return 'no';
  }

  function typedInputDecision(index, u, q) {
    if (!TYPED_INPUT_HANDLES[u.h]) return null;
    var review = { handle: u.h, state: 'source_unavailable', purchase_approved: false,
      source_fact_sha256: null, source_revision: '', source_url: '', source_kind: '',
      printed_values_v: [], nominal_input_v: null, operating_range_v: null,
      load_footnote: '', requested_supply: q.power };
    var overlay = index && index.input_voltage_v2;
    if (!overlay || overlay.schema !== 'builder-input-voltage/v2' ||
        overlay.bridge_sha256 !== TYPED_INPUT_BRIDGE_SHA ||
        overlay.source_sidecar_sha256 !== TYPED_INPUT_SOURCE_SHA ||
        !overlay.records || !Array.isArray(overlay.target_handles) ||
        overlay.target_handles.length !== 22 ||
        overlay.target_handles.indexOf(u.h) < 0 ||
        overlay.delivered_variant_status !== 'unknown_not_proven_by_catalogue_identity') return review;
    var record = overlay.records[u.h], fact = record && record.typed;
    if (!record || !fact || !/^[a-f0-9]{64}$/.test(record.source_fact_content_sha256 || '') ||
        fact.source_sidecar_sha256 !== TYPED_INPUT_SOURCE_SHA ||
        fact.source_status !== 'accepted_printed_fact' ||
        fact.regional_delivered_setting_status !== 'unknown' ||
        !fact.evidence || !fact.evidence.revision || !fact.evidence.url) return review;
    review.source_fact_sha256 = record.source_fact_content_sha256;
    review.source_revision = fact.evidence.revision;
    review.source_url = fact.evidence.url;
    review.source_page = fact.evidence.page;
    review.source_kind = fact.kind;
    review.literal_input_expression = fact.literal_input_expression || '';
    review.printed_values_v = Array.isArray(fact.ordered_printed_values_v) ? fact.ordered_printed_values_v.slice() : [];
    review.nominal_input_v = fact.nominal_input_v;
    review.operating_range_v = Array.isArray(fact.operating_range_v) ? fact.operating_range_v.slice() : null;
    review.load_footnote = fact.load_footnote || '';
    if (!q.power || q.power === 'unknown') review.state = 'supply_unspecified';
    else if (q.power === '208-240') review.state = 'exact_supply_needed';
    else if (/^\d+$/.test(String(q.power))) {
      var supply = Number(q.power);
      if (fact.kind === 'multi_value_input_list' && review.printed_values_v.length)
        review.state = review.printed_values_v.indexOf(supply) >= 0 ? 'listed_candidate' : 'not_listed_review';
      else if (fact.kind === 'operating_range_only' && review.operating_range_v &&
               fact.nominal_input_v === null)
        review.state = 'range_only_review';
      else if (fact.kind === 'explicit_nominal_plus_range' &&
               Number.isInteger(fact.nominal_input_v))
        review.state = fact.nominal_input_v === supply ? 'nominal_candidate' : 'different_nominal_review';
    }
    // No bridge record proves the Canadian delivered unit or load-dependent envelope.
    // A value absent from a printed list is review, not a proven negative.
    return review;
  }


  // J60C/J60Ci source scope. This sidecar is independent of the pinned DB21
  // physical manifest; changing it cannot silently rebind unrelated products.
  var J60_SOURCE = {"schema":"builder-j60-source/v1","pdf_sha256":"c1d6a270990432fb544f4056dc97bf50bb7b028675500c1e7955134deed71738","revision":"J60C.04U Rev 9/4/26","url":"https://xpcc.com/wp-content/uploads/J60C-flyer.pdf","records":{"xpc-j60c-600":{"nominal_input_v":120,"ff":"R","ru":1,"dp":8.5,"volt":"120","ph":"1","ph_src":"d","rf":6.0,"rh":0.0,"rtab":[[0,30,86],[0,40,64],[0,80,35],[0,120,23],[0,160,17],[0,200,14],[0,240,11],[0,280,9],[0,320,8],[0,360,6]],"rpk":"","rtmethod":"manufacturer_approximate_25c","rec":"4 battery-backed NEMA 5-15R + 1 surge-only NEMA 5-15R","battery_backed_outlets":4,"surge_only_outlets":1,"outlet_type":"NEMA 5-15R","physical":{"rack":{"role":"separate_chassis","enclosure_handles":[],"u":1,"chassis_depth_in":8.5,"depth_role":"own_clearance","installed_depth_in":null},"wall":{"role":"manufacturer_supported_but_not_builder_modeled"},"source":[{"fact":"rack.role","sha256":"c1d6a270990432fb544f4056dc97bf50bb7b028675500c1e7955134deed71738","page":"1","locator":"1U rack mount UPS and rack brackets included","basis":"manufacturer"},{"fact":"rack.u","sha256":"c1d6a270990432fb544f4056dc97bf50bb7b028675500c1e7955134deed71738","page":"1-2","locator":"1U rack mount; 1.7 in chassis height","basis":"manufacturer"},{"fact":"rack.chassis_depth_in","sha256":"c1d6a270990432fb544f4056dc97bf50bb7b028675500c1e7955134deed71738","page":"2","locator":"17.2 x 8.5 x 1.7 in W x D x H","basis":"manufacturer"},{"fact":"rack.depth_role","sha256":"c1d6a270990432fb544f4056dc97bf50bb7b028675500c1e7955134deed71738","page":"2","locator":"8.5 in chassis depth; installed cable clearance unstated","basis":"derived"}]},"source":[{"fact":"nominal_input_v","sha256":"c1d6a270990432fb544f4056dc97bf50bb7b028675500c1e7955134deed71738","page":"2","locator":"model selection guide INPUT Voltage","basis":"manufacturer"},{"fact":"rtab","sha256":"c1d6a270990432fb544f4056dc97bf50bb7b028675500c1e7955134deed71738","page":"2","locator":"BATTERY RUNTIMES 30-360 W at 25 C; approximate","basis":"manufacturer"},{"fact":"rec","sha256":"c1d6a270990432fb544f4056dc97bf50bb7b028675500c1e7955134deed71738","page":"2","locator":"Receptacles 4 battery backup + 1 surge only","basis":"manufacturer"},{"fact":"wall","sha256":"c1d6a270990432fb544f4056dc97bf50bb7b028675500c1e7955134deed71738","page":"1","locator":"rack and wall mount brackets included","basis":"manufacturer"}]},"xpc-j60ci-600":{"nominal_input_v":230,"ff":"R","ru":1,"dp":8.5,"volt":"230","ph":"1","ph_src":"d","rf":6.0,"rh":0.0,"rtab":[[0,30,86],[0,40,64],[0,80,35],[0,120,23],[0,160,17],[0,200,14],[0,240,11],[0,280,9],[0,320,8],[0,360,6]],"rpk":"","rtmethod":"manufacturer_approximate_25c","rec":"4 battery-backed IEC C13 + 1 surge-only IEC C13","battery_backed_outlets":4,"surge_only_outlets":1,"outlet_type":"IEC C13","physical":{"rack":{"role":"separate_chassis","enclosure_handles":[],"u":1,"chassis_depth_in":8.5,"depth_role":"own_clearance","installed_depth_in":null},"wall":{"role":"manufacturer_supported_but_not_builder_modeled"},"source":[{"fact":"rack.role","sha256":"c1d6a270990432fb544f4056dc97bf50bb7b028675500c1e7955134deed71738","page":"1","locator":"1U rack mount UPS and rack brackets included","basis":"manufacturer"},{"fact":"rack.u","sha256":"c1d6a270990432fb544f4056dc97bf50bb7b028675500c1e7955134deed71738","page":"1-2","locator":"1U rack mount; 1.7 in chassis height","basis":"manufacturer"},{"fact":"rack.chassis_depth_in","sha256":"c1d6a270990432fb544f4056dc97bf50bb7b028675500c1e7955134deed71738","page":"2","locator":"17.2 x 8.5 x 1.7 in W x D x H","basis":"manufacturer"},{"fact":"rack.depth_role","sha256":"c1d6a270990432fb544f4056dc97bf50bb7b028675500c1e7955134deed71738","page":"2","locator":"8.5 in chassis depth; installed cable clearance unstated","basis":"derived"}]},"source":[{"fact":"nominal_input_v","sha256":"c1d6a270990432fb544f4056dc97bf50bb7b028675500c1e7955134deed71738","page":"2","locator":"model selection guide INPUT Voltage","basis":"manufacturer"},{"fact":"rtab","sha256":"c1d6a270990432fb544f4056dc97bf50bb7b028675500c1e7955134deed71738","page":"2","locator":"BATTERY RUNTIMES 30-360 W at 25 C; approximate","basis":"manufacturer"},{"fact":"rec","sha256":"c1d6a270990432fb544f4056dc97bf50bb7b028675500c1e7955134deed71738","page":"2","locator":"Receptacles 4 battery backup + 1 surge only","basis":"manufacturer"},{"fact":"wall","sha256":"c1d6a270990432fb544f4056dc97bf50bb7b028675500c1e7955134deed71738","page":"1","locator":"rack and wall mount brackets included","basis":"manufacturer"}]}}};
  function j60Decision(index, u, q) {
    var expected = J60_SOURCE.records[u.h];
    if (!expected) return null;
    var overlay = index && index.j60_2026;
    var fields = ['ff', 'ru', 'dp', 'volt', 'ph', 'ph_src', 'rf', 'rh',
      'rtab', 'rpk', 'rtmethod', 'rec'];
    var valid = !!overlay && JSON.stringify(overlay) === JSON.stringify(J60_SOURCE) &&
      fields.every(function (field) { return JSON.stringify(u[field]) === JSON.stringify(expected[field]); });
    if (!valid) return { state: 'source_unavailable', source: null };
    var power = String(q.power || 'unknown');
    if (power === '208-240') return expected.nominal_input_v === 230 ?
      { state: 'exact_supply_needed', source: expected } :
      { state: 'wrong_variant', source: expected };
    if (/^\d+$/.test(power) && Number(power) !== expected.nominal_input_v)
      return { state: 'wrong_variant', source: expected };
    return { state: power === 'unknown' ? 'supply_unspecified' : 'nominal_review',
      source: expected };
  }

  // Runtime at the buyer's load from the two published points (half and full load), power law between them.
  // Between 50 % and 100 % load: interpolated, labelled "estimate". Below 50 %: a lower bound (at least the half-load
  // runtime; true because runtime rises as load falls). Above 100 % or with an inverted pair (E.13): null.
  function runtimeAt(u, loadW) {
    var W = u.w, rh = u.rh, rf = u.rf;
    if (!W || !rh || !rf || rh < rf || loadW <= 0) return null;
    var frac = loadW / W;
    if (frac > 1) return null;
    if (frac < 0.5) return { min: rh, est: false, atLeast: true };
    var a = Math.log(rh / rf) / Math.log(2);
    var t = rf * Math.pow(1 / frac, a);
    return { min: t, est: frac !== 1 && frac !== 0.5, atLeast: false };
  }

  // C.06 runtime tables: pts = [[packs, load_w, minutes], ...]. An exact load is a tabulated point;
  // a load between two points is interpolated and labelled an estimate. Never infer above the heaviest load.
  // Below the lightest load, only an unadjusted published table supports a lower-bound runtime.
  function tableAt(pts, n, loadW, method) {
    if (!pts || !(loadW > 0)) return null;
    var p = pts.filter(function (x) { return x[0] === n && x[1] > 0 && x[2] > 0; })
               .sort(function (a, b) { return a[1] - b[1]; });
    if (!p.length) return null;
    if (loadW > p[p.length - 1][1]) return null;
    for (var i = 0; i < p.length; i++) if (p[i][1] === loadW) return { min: p[i][2], est: !!method, atLeast: false };
    var lo = null, hi = null;
    for (var j = 0; j < p.length; j++) { if (p[j][1] < loadW) lo = p[j]; else if (!hi) hi = p[j]; }
    if (hi && !lo) return method ? null : { min: hi[2], est: false, atLeast: true };
    if (!hi || !lo || lo[2] < hi[2]) return null;
    var a = Math.log(lo[2] / hi[2]) / Math.log(hi[1] / lo[1]);
    return { min: hi[2] * Math.pow(hi[1] / loadW, a), est: true, atLeast: false };
  }

  // Fewest packs of the table's pack model that meet the runtime at the load (0..MAX_PACKS), or null.
  function packsFor(u, q) {
    if (!u.rtab || !u.rpk) return null;
    for (var n = 1; n <= MAX_PACKS; n++) {
      var r = tableAt(u.rtab, n, q.load, u.rtmethod);
      if (r && r.min >= q.runtime) return { n: n, rt: r };
    }
    return null;
  }

  // Runtime of a configured solution (the buyer's pack model and count): known only when the table is for that pack.
  function packRuntime(e, sel, loadW) {
    var u = e.u, pk = e.opts.e[sel.eI];
    if (!u.rtab || !pk || pk[0] !== u.rpk || !(sel.e > 0)) return null;
    return tableAt(u.rtab, Math.min(MAX_PACKS, sel.e | 0), loadW, u.rtmethod);
  }

  // Manufacturer bundle reference only. Never feeds e.rt, e.need or cart
  // eligibility: current UPB package, output path and site remain review holds.
  function bundleRuntimeReference(e, q) {
    if (!e || !e.bundleReview || !e.bundleSource) return null;
    var s = e.bundleSource;
    // Pricebook contents establish no usable runtime curve for these bundles.
    if (s.source_scope === 'manufacturer_description_only')
      return { state: 'transformer_path_review' };
    if (s.runtime_pack_handle !== e.u.rpk || s.pack_count_in_bundle !== 1 ||
        !e.u.rtab || e.u.rtab.some(function (p) { return p[0] === 0; }))
      return { state: 'source_mismatch' };
    var exact = e.u.rtab.filter(function (p) { return p[0] === 1 && p[1] === 5000; });
    if (exact.length !== 1 || exact[0][2] !== s.runtime_one_pack_5000w_min)
      return { state: 'source_mismatch' };
    if (s.transformer_output_path_hold) return { state: 'transformer_path_review' };
    // Table identity is accepted; output-setting capacity and load-specific
    // runtime qualification are not. Even a URL-provided 240 V value stays held.
    return { state: 'output_setting_review' };
  }

  function rows(index) {
    var F = index.fields, out = [];
    for (var i = 0; i < index.u.length; i++) {
      var r = index.u[i], o = {};
      for (var k = 0; k < F.length; k++) o[F[k]] = r[k];
      o.outputConnection = index.output_connection_v1 && index.output_connection_v1.records ?
        index.output_connection_v1.records[o.h] || null : null;
      if (OEM_INCLUDED_CARD[o.h] === 1) o.card = '1';
      out.push(o);
    }
    return out;
  }

  function evaluate(u, q, index) {
    var facts = [], confirm = 0;
    var bundleReview = P91_BUNDLE_REVIEW[u.h] === 1;
    if (!u.w || u.w < q.load) return null;                       // too small: never shown
    // A single-phase buyer cannot use a three-phase UPS. A title marker only holds a row when
    // the phase fact is missing; it never proves compatibility. Three-phase buyers use the quote path.
    if (u.ph === '3' || /THREE[ -]PHASE|TRIPHAS/i.test((u.t || '') + ' ' + (u.tf || ''))) return null;
    var j60 = j60Decision(index, u, q);
    if (j60 && j60.state === 'wrong_variant') return null;
    var inputVoltage = typedInputDecision(index, u, q);
    var v = j60 || inputVoltage ? 'confirm' : voltFits(q.power, u.volt);
    if (v === 'no') return null;
    if (v === 'confirm') { confirm++; facts.push({ k: 'volt', s: 'confirm' }); }
    if (q.power === 'three-phase') return null;                  // three-phase goes to the quote path
    // A bundle's recorded plug can describe the bare UPS or one bundled bypass; its
    // delivered topology is unresolved, so neither a positive nor a negative plug claim is safe.
    var pf = bundleReview && q.outlet && q.outlet !== 'unknown' ? 'confirm' : plugFits(q.outlet, u.plug);
    var mismatch = pf === 'no';
    var plugUnknown = pf === 'confirm';
    if (plugUnknown) { confirm++; }
    if (q.fit === 'rack' && u.ff !== 'R' && u.ff !== 'C') return null;
    if (q.fit === 'tower' && u.ff !== 'T' && u.ff !== 'C') return null;
    // Candidate UPS dimensions still order equally held rows; only the
    // configured physical assessment can establish a complete fit.
    if (q.fit === 'rack' && q.rackU && !u.ru) confirm++;
    if (q.fit === 'rack' && q.depth && !u.dp) confirm++;
    if (q.generator && u.tp !== 'O') return null;
    if (!bundleReview && q.card && u.card === '0' && !hasType(u, index, 'c')) return null;
    if (q.card && u.card === '') confirm++;
    var hasBaseTable = u.rtab && u.rtab.some(function (p) { return p[0] === 0; });
    var rt = bundleReview || (j60 && j60.state === 'source_unavailable') ? null :
      (hasBaseTable ? tableAt(u.rtab, 0, q.load, u.rtmethod) : runtimeAt(u, q.load));
    var packs = !bundleReview && u.xrt ? countType(u, index, 'e') : 0;
    var meets = rt ? rt.min >= q.runtime : false;
    var need = meets || bundleReview ? null : packsFor(u, q); // no accepted bundle total-versus-additional pack count
    if (!rt) confirm++;
    var loadPct = q.load / u.w;
    // The solution: the UPS, plus one compatible pack when the UPS alone falls short of the runtime (how many packs
    // it needs comes with the C.06 runtime tables), plus a compatible network card when one is required and not
    // included. Items are [handle, title, price_cents]; price 0 = on quote.
    var items = [[u.h, u.t, u.p]];
    if (!meets && packs) { var pk = firstOf(u, index, 'e'); if (pk) items.push(pk); }
    if (!bundleReview && q.card && u.card === '0') { var cd = firstOf(u, index, 'c'); if (cd) items.push(cd); }
    // Dependency lines (OEM-PARITY #9): what the buyer must have or add for this unit to work, in plain words.
    // Codes, rendered by the UI from strings: [code, detail].
    var deps = [];
    var P = normPlug(u.plug);
    if (P.indexOf('L5-30P') !== -1) deps.push(['needs_l530', '']);
    else if (P.indexOf('L5-20P') !== -1) deps.push(['needs_l520', '']);
    else if (P.indexOf('L6-30P') !== -1) deps.push(['needs_l630', '']);
    else if (P.indexOf('L6-20P') !== -1) deps.push(['needs_l620', '']);
    else if (P.indexOf('5-20P') !== -1) deps.push(['needs_520', '']);
    else if (/HARD ?WIRE/.test(P)) deps.push(['hardwired', '']);
    // only when the manufacturer data says the card is not included; an unknown card status stays 'to confirm'
    if (u.card === '0') { var cdd = firstOf(u, index, 'c'); if (cdd) deps.push(['card_separate', cdd[1]]); }
    if ((u.ff === 'R' || u.ff === 'C')) { var rl = firstOf(u, index, 'r'); if (rl) deps.push(['rails', rl[1]]); }
    if (bundleReview) deps = []; // recorded plug/rails/component links do not prove the sold bundle's installed BOM
    var total = 0, priced = true;
    for (var j = 0; j < items.length; j++) { if (items[j][2]) total += items[j][2]; else priced = false; }
    // Add-ons (W1): every evidenced, compatible accessory of each kind, in stock first then cheapest. The buyer picks
    // one per kind (bypass modules differ in output wiring, so none is chosen for them) and a pack quantity.
    var opts = bundleReview ? { e: [], c: [], x: [], r: [] } :
      { e: u.xrt ? listOf(u, index, 'e') : [], c: u.card !== '1' ? listOf(u, index, 'c') : [],
        x: listOf(u, index, 'x'), r: (u.ff === 'R' || u.ff === 'C') ? listOf(u, index, 'r') : [] };
    var cardReady = !q.card || u.card === '1' || (u.card === '0' && opts.c.length > 0);
    var rpkI = -1;
    for (var m = 0; m < opts.e.length; m++) if (opts.e[m][0] === u.rpk) rpkI = m;
    if (need && rpkI < 0) need = null;               // the table's pack is not a linked, listed pack
    var def = { e: need ? need.n : ((!meets && packs && opts.e.length) ? 1 : 0), eI: need ? rpkI : 0,
                c: (q.card && u.card === '0' && opts.c.length) ? 0 : -1, x: -1, r: -1 };
    // Builder reviews (2 Oct 2026): the price a buyer pays for the default solution (UPS + its default pack count +
    // the required card), used for the last ranking tie-break. Any unpriced part leaves it unknown (ranked last).
    var cfgTotal = u.p || 0;
    if (cfgTotal && def.e > 0) { var dpk = opts.e[def.eI]; cfgTotal = dpk && dpk[2] ? cfgTotal + dpk[2] * def.e : 0; }
    if (cfgTotal && def.c >= 0) { var dcd = opts.c[def.c]; cfgTotal = dcd && dcd[2] ? cfgTotal + dcd[2] : 0; }
    var result = {
      items: items, total: total, priced: priced, deps: deps, opts: opts, def: def, need: need,
      u: u, rt: rt, meets: meets, packs: packs, cardReady: cardReady, loadPct: loadPct, cfgTotal: cfgTotal, confirm: confirm, mismatch: mismatch, plugUnknown: plugUnknown,
      ord: XPC[String(u.v || '').toLowerCase()] ? 0 : 1, bundleReview: bundleReview,
      bundleSource: bundleReview ?
        (index.p91_bundle_v1 && index.p91_bundle_v1.records && index.p91_bundle_v1.records[u.h]) ||
        (index.p91_tb_extension_v1 && index.p91_tb_extension_v1.records && index.p91_tb_extension_v1.records[u.h]) || null : null,
      inputVoltage: inputVoltage, j60: j60
    };
    result.physical = buyerPhysicalFit(result, def, q, index);
    return result;
  }

  function firstOf(u, index, t) {
    var acc = u.acc || [], best = null;
    for (var i = 0; i < acc.length; i++) {
      var a = index.ac[acc[i]];
      if (eligibleAccessory(a, t, u) && (!best || (a[4] && !best[4]) || (a[4] === best[4] && a[3] && (!best[3] || a[3] < best[3])))) best = a;
    }
    return best ? [best[0], best[1], best[3]] : null;
  }

  function listOf(u, index, t) {
    var acc = u.acc || [], out = [], seen = {};
    for (var i = 0; i < acc.length; i++) {
      var a = index.ac[acc[i]];
      if (eligibleAccessory(a, t, u) && !seen[a[0]]) { seen[a[0]] = 1; out.push(a); }
    }
    out.sort(function (a, b) { return (b[4] ? 1 : 0) - (a[4] ? 1 : 0) || (a[3] || 1e12) - (b[3] || 1e12); });
    return out.map(function (a) { return [a[0], a[1], a[3]]; });
  }

  // The solution the buyer configured: the UPS plus the chosen add-ons. sel = { e: pack qty, eI: pack index,
  // c/x/r: option index or -1 }. Returns items [handle, title, price_cents, qty] and the total (price 0 = on quote).
  function configure(e, sel) {
    var o = e.opts, items = [[e.u.h, e.u.t, e.u.p, 1]];
    var n = Math.max(0, Math.min(MAX_PACKS, sel.e | 0));
    if (n && o.e[sel.eI]) items.push(o.e[sel.eI].concat([n]));
    ['c', 'x', 'r'].forEach(function (k) { if (sel[k] >= 0 && o[k][sel[k]]) items.push(o[k][sel[k]].concat([1])); });
    var total = 0, priced = true;
    for (var j = 0; j < items.length; j++) { if (items[j][2]) total += items[j][2] * items[j][3]; else priced = false; }
    return { items: items, total: total, priced: priced };
  }

  // One source-bound assessment of the configured, per-system BOM. The legacy
  // UPS height/depth fields describe its chassis only; they cannot pass a whole
  // system with selected packs and installation hardware.
  function physicalFit(e, sel, q, index) {
    var fit = { status: 'review', orientation: q.fit, known_min_u: 0,
      required_u: null, available_u: q.rackU || 0,
      max_known_installed_depth_in: 0, known_min_depth_in: 0,
      required_depth_in: null, available_depth_in: q.depth || 0,
      missing: [], reasons: [] };
    var physical = index && index.physical || {};
    if (e.j60 && e.j60.source) {
      physical = Object.assign({}, physical);
      physical[e.u.h] = e.j60.source.physical;
    }
    var items = configure(e, sel).items;
    var selected = {};
    items.forEach(function (it) { selected[it[0]] = (selected[it[0]] || 0) + it[3]; });
    function cited(record, fact) {
      return record && Array.isArray(record.source) && record.source.some(function (s) {
        return s && s.fact === fact && /^[a-f0-9]{64}$/i.test(s.sha256 || '') &&
          !!String(s.page || s.locator || '').trim() &&
          ['manufacturer', 'store_metafield', 'derived', 'reviewed_relation'].indexOf(s.basis) >= 0;
      });
    }
    function missing(handle, qty, fact) { fit.missing.push({ handle: handle, quantity: qty, fact: fact }); }
    function selectedEnclosure(handle, rack) {
      return Array.isArray(rack.enclosure_handles) && rack.enclosure_handles.some(function (target) {
        var enclosure = physical[target];
        return target !== handle && selected[target] && enclosure && enclosure.rack &&
          enclosure.rack.role === 'separate_chassis' && cited(enclosure, 'rack.role');
      });
    }
    // GS27 Rack Space is for the exact sold TB bundle, not one UPS chassis.
    // Count it once, and retain review for unverified contents and clearance.
    var gs27 = index && index.gs27_bundle_rack_space_v1;
    var bundleSpace = gs27 && gs27.accepted_sha256 ===
      '9f1d5870544f72383e8f496ac60e186cf283866ad7aa1fb26f191b0e4be17fb3' &&
      gs27.records && gs27.records[e.u.h];
    var bundleTotalU = e.bundleReview && bundleSpace && bundleSpace.scope === 'sold_bundle_total' &&
      bundleSpace.source_sha256 === '4265f56d398fd9b60ab5b21b9b39cf669f5da38b72ec2000de0a1ccf507ee767' &&
      bundleSpace.pdf_page === 26 && Number.isInteger(bundleSpace.total_u) && bundleSpace.total_u > 0 ?
      bundleSpace.total_u : 0;
    var gs28 = index && index.p91_tb_extension_v1;
    var extendedSpace = gs28 && gs28.accepted_decision_sha256 ===
      'f9592c4a700aebecf89fd9b6f8bea88ec105c8f782ad7df9d653991b361417c6' &&
      gs28.source_pdf_sha256 === '4265f56d398fd9b60ab5b21b9b39cf669f5da38b72ec2000de0a1ccf507ee767' &&
      gs28.records && gs28.records[e.u.h];
    if (!bundleTotalU && e.bundleReview && extendedSpace &&
        extendedSpace.source_pdf_sha256 === gs28.source_pdf_sha256 &&
        extendedSpace.source_page === 26 &&
        Number.isInteger(extendedSpace.total_u) && extendedSpace.total_u > 0)
      bundleTotalU = extendedSpace.total_u;
    if (sel.e > 0 && !e.opts.e[sel.eI]) missing((sel.ids && sel.ids.eI) || e.u.h, sel.e, 'selected_pack');
    if (e.bundleReview) missing(e.u.h, 1, 'bundle_components');
    if (q.fit === 'either') {
      if (q.rackU || q.depth || e.u.ff === 'C') {
        fit.reasons.push('mounting_choice');
        return fit;
      }
      if (e.u.ff !== 'R' && e.u.ff !== 'T') {
        fit.reasons.push('mounting_choice');
        return fit;
      }
      fit.orientation = e.u.ff === 'R' ? 'rack' : 'tower';
    }
    if (fit.orientation === 'tower') {
      items.forEach(function (it) {
        var record = physical[it[0]];
        if (record && record.tower && record.tower.role === 'unsupported' && cited(record, 'tower.role'))
          fit.reasons.push('tower_unsupported');
        else if (record && record.tower && record.tower.role === 'inside_selected_enclosure') {
          var tower = record.tower, target = physical[e.u.h];
          var rackCard = record.rack;
          var contained = it[0] === 'xpc-snmp-2pv3' && it[3] === 1 &&
            selected[e.u.h] === 1 && items[0][0] === e.u.h &&
            items.filter(function (part) {
              return SNMP_2PV3_MODELS[part[0]];
            }).length === 1 &&
            tower.max_supported_quantity_per_enclosure === 1 &&
            Array.isArray(tower.enclosure_handles) &&
            tower.enclosure_handles.length === SNMP_2PV3_TOWER_ENCLOSURES.length &&
            SNMP_2PV3_TOWER_ENCLOSURES.every(function (h) {
              return tower.enclosure_handles.indexOf(h) >= 0;
            }) && tower.enclosure_handles.indexOf(e.u.h) >= 0 &&
            rackCard && rackCard.role === 'inside_selected_enclosure' &&
            Array.isArray(rackCard.enclosure_handles) &&
            rackCard.enclosure_handles.length === tower.enclosure_handles.length &&
            tower.enclosure_handles.every(function (h) {
              return rackCard.enclosure_handles.indexOf(h) >= 0;
            }) && cited(record, 'rack.role') && cited(record, 'rack.enclosure_handles') &&
            target && target.tower && target.tower.role === 'supported' &&
            cited(target, 'tower.role') && cited(record, 'tower.role') &&
            cited(record, 'tower.enclosure_handles') &&
            cited(record, 'tower.max_supported_quantity_per_enclosure');
          if (!contained) missing(it[0], it[3], 'tower.enclosure_handles');
        }
        else if (record && record.tower && record.tower.role === 'supported_with_selected_ups') {
          var packTower = record.tower, packTarget = P80_TOWER_PACK_PAIRS[it[0]];
          var targetRecord = physical[packTarget];
          var pairSupported = packTarget === e.u.h && it[3] === 1 &&
            selected[packTarget] === 1 && selected[it[0]] === 1 &&
            items[0][0] === packTarget &&
            items.filter(function (part) {
              return SNMP_2PV3_MODELS[part[0]];
            }).length === 1 &&
            packTower.max_verified_pack_quantity === 1 &&
            Array.isArray(packTower.selected_ups_handles) &&
            packTower.selected_ups_handles.length === 1 &&
            packTower.selected_ups_handles[0] === packTarget &&
            record.rack && record.rack.role === 'separate_chassis' &&
            cited(record, 'rack.role') &&
            targetRecord && targetRecord.tower && targetRecord.tower.role === 'supported' &&
            cited(targetRecord, 'tower.role') && cited(record, 'tower.role') &&
            cited(record, 'tower.selected_ups_handles') &&
            cited(record, 'tower.max_verified_pack_quantity');
          if (!pairSupported) missing(it[0], it[3], 'tower.selected_ups_handles');
        }
        else if (!record || !record.tower || record.tower.role !== 'supported' ||
                 !cited(record, 'tower.role')) missing(it[0], it[3], 'tower.role');
      });
      fit.status = fit.reasons.length ? 'mismatch' : (fit.missing.length ? 'review' : 'pass');
      return fit;
    }
    if (bundleTotalU) fit.known_min_u = bundleTotalU;
    items.forEach(function (it) {
      var handle = it[0], qty = it[3], record = physical[handle];
      if (handle === e.u.h && bundleTotalU) return; // already counted the whole sold bundle
      var rack = record && record.rack;
      if (!rack || !cited(record, 'rack.role')) { missing(handle, qty, 'rack.role'); return; }
      if (rack.role === 'separate_chassis') {
        if (typeof rack.u === 'number' && Number.isFinite(rack.u) && rack.u > 0 && cited(record, 'rack.u'))
          fit.known_min_u += rack.u * qty;
        else missing(handle, qty, 'rack.u');
      } else if (rack.role === 'inside_selected_enclosure' || rack.role === 'support_hardware') {
        if (!selectedEnclosure(handle, rack) ||
            !cited(record, 'rack.enclosure_handles')) missing(handle, qty, 'rack.enclosure_handles');
      } else { missing(handle, qty, 'rack.role'); return; }
      if (rack.role === 'separate_chassis' && typeof rack.chassis_depth_in === 'number' && Number.isFinite(rack.chassis_depth_in) &&
          rack.chassis_depth_in > 0 && cited(record, 'rack.chassis_depth_in'))
        fit.known_min_depth_in = Math.max(fit.known_min_depth_in, rack.chassis_depth_in);
      if (!cited(record, 'rack.depth_role')) { missing(handle, qty, 'rack.depth_role'); return; }
      if (rack.depth_role === 'own_clearance') {
        if (typeof rack.installed_depth_in === 'number' && Number.isFinite(rack.installed_depth_in) &&
            rack.installed_depth_in > 0 && cited(record, 'rack.installed_depth_in')) {
          if (rack.chassis_depth_in > rack.installed_depth_in && cited(record, 'rack.chassis_depth_in'))
            missing(handle, qty, 'rack.installed_depth_in');
          else fit.max_known_installed_depth_in = Math.max(fit.max_known_installed_depth_in, rack.installed_depth_in);
          fit.known_min_depth_in = Math.max(fit.known_min_depth_in, rack.installed_depth_in);
        } else missing(handle, qty, 'rack.installed_depth_in');
      } else if (rack.depth_role === 'covered_by_enclosure' || rack.depth_role === 'no_separate_clearance') {
        if (rack.role === 'separate_chassis' || !selectedEnclosure(handle, rack) ||
            !cited(record, 'rack.enclosure_handles')) missing(handle, qty, 'rack.depth_role');
      } else missing(handle, qty, 'rack.depth_role');
    });
    var spaceUnknown = fit.missing.some(function (m) {
      return ['rack.role', 'rack.u', 'rack.enclosure_handles', 'selected_pack',
        'bundle_components'].indexOf(m.fact) >= 0;
    });
    var depthUnknown = fit.missing.some(function (m) {
      return ['rack.role', 'rack.enclosure_handles', 'rack.depth_role',
        'rack.installed_depth_in', 'selected_pack', 'bundle_components'].indexOf(m.fact) >= 0;
    });
    if (!spaceUnknown) fit.required_u = fit.known_min_u;
    if (!depthUnknown) fit.required_depth_in = fit.max_known_installed_depth_in;
    if (fit.available_u && fit.known_min_u > fit.available_u) fit.reasons.push('rack_u');
    if (fit.available_depth_in && fit.known_min_depth_in > fit.available_depth_in) fit.reasons.push('depth');
    if (fit.reasons.length) fit.status = 'mismatch';
    else if (fit.missing.length) fit.status = 'review';
    else fit.status = 'pass';
    return fit;
  }

  // A cited tower role describes equipment capability. The four reviewed UPS
  // need a current buyer answer for the exact bare, internal-card or one-pack BOM.
  var TOWER_PLACEMENT_VERSION = 'first-four-placement/v4';
  // The reviewed combined source hash binds every new placement answer.
  var TOWER_MANIFEST_SHA = '1577f0bf6106c416b7e0404f9672c82ebe06c73b68d79b69cd50e7b86242c324';
  // Exact reviewed physical records from the current qualified DB21 manifest.
  // Comparing the selected full records also detects an index whose declared
  // manifest hash was left unchanged while its facts or citations were edited.
  var TOWER_PHYSICAL_CONTRACT_SHA = '536b7c90f7ce1f92a79c715da60c4245b0e634bd9cb8c0a0dab0554cdb113dc5';
  var TOWER_PHYSICAL_CONTRACT = {"xpc-p80-1500":{"sku":null,"rack":{"role":"separate_chassis","enclosure_handles":[],"u":2.0,"chassis_depth_in":18.9,"depth_role":"own_clearance","installed_depth_in":null},"tower":{"role":"supported"},"source":[{"fact":"rack.role","sha256":"4265f56d398fd9b60ab5b21b9b39cf669f5da38b72ec2000de0a1ccf507ee767","locator":"PDF p6 pack/UPS row and depth footnote","basis":"reviewed_relation"},{"fact":"rack.u","sha256":"4265f56d398fd9b60ab5b21b9b39cf669f5da38b72ec2000de0a1ccf507ee767","locator":"PDF p6 pack/UPS row and depth footnote","basis":"manufacturer"},{"fact":"rack.chassis_depth_in","sha256":"4265f56d398fd9b60ab5b21b9b39cf669f5da38b72ec2000de0a1ccf507ee767","locator":"PDF p6 pack/UPS row and depth footnote","basis":"manufacturer"},{"fact":"rack.depth_role","sha256":"4265f56d398fd9b60ab5b21b9b39cf669f5da38b72ec2000de0a1ccf507ee767","locator":"PDF p6 pack/UPS row and depth footnote","basis":"reviewed_relation"},{"fact":"tower.role","sha256":"fc88d01ae63ddc54a7edfc8aba73febfecf051ac0f168a7e757bef41d0a91f72","locator":"PDF p2: P80-1500 model column, rack/tower series and included tower pedestals; 2026-09-11 revision","basis":"manufacturer"}]},"xpc-p80-3000v2":{"sku":null,"rack":{"role":"separate_chassis","enclosure_handles":[],"u":2.0,"chassis_depth_in":23.6,"depth_role":"own_clearance","installed_depth_in":null},"tower":{"role":"supported"},"source":[{"fact":"rack.role","sha256":"4265f56d398fd9b60ab5b21b9b39cf669f5da38b72ec2000de0a1ccf507ee767","locator":"PDF p6 pack/UPS row and depth footnote","basis":"reviewed_relation"},{"fact":"rack.u","sha256":"4265f56d398fd9b60ab5b21b9b39cf669f5da38b72ec2000de0a1ccf507ee767","locator":"PDF p6 pack/UPS row and depth footnote","basis":"manufacturer"},{"fact":"rack.chassis_depth_in","sha256":"4265f56d398fd9b60ab5b21b9b39cf669f5da38b72ec2000de0a1ccf507ee767","locator":"PDF p6 pack/UPS row and depth footnote","basis":"manufacturer"},{"fact":"rack.depth_role","sha256":"4265f56d398fd9b60ab5b21b9b39cf669f5da38b72ec2000de0a1ccf507ee767","locator":"PDF p6 pack/UPS row and depth footnote","basis":"reviewed_relation"},{"fact":"tower.role","sha256":"fc88d01ae63ddc54a7edfc8aba73febfecf051ac0f168a7e757bef41d0a91f72","locator":"PDF p2: P80 rack/tower series, included tower pedestals; P80-3000V2 listed in series","basis":"manufacturer"}]},"xpc-p91-1500":{"sku":null,"rack":{"role":"separate_chassis","enclosure_handles":[],"u":2.0,"chassis_depth_in":15.1,"depth_role":"own_clearance","installed_depth_in":null},"tower":{"role":"supported"},"source":[{"fact":"rack.role","sha256":"4265f56d398fd9b60ab5b21b9b39cf669f5da38b72ec2000de0a1ccf507ee767","locator":"PDF p15 pack/UPS row and depth footnote","basis":"reviewed_relation"},{"fact":"rack.u","sha256":"4265f56d398fd9b60ab5b21b9b39cf669f5da38b72ec2000de0a1ccf507ee767","locator":"PDF p15 pack/UPS row and depth footnote","basis":"manufacturer"},{"fact":"rack.chassis_depth_in","sha256":"4265f56d398fd9b60ab5b21b9b39cf669f5da38b72ec2000de0a1ccf507ee767","locator":"PDF p15 pack/UPS row and depth footnote","basis":"manufacturer"},{"fact":"rack.depth_role","sha256":"4265f56d398fd9b60ab5b21b9b39cf669f5da38b72ec2000de0a1ccf507ee767","locator":"PDF p15 pack/UPS row and depth footnote","basis":"reviewed_relation"},{"fact":"tower.role","sha256":"fbd68fd39aa90358cac31c23e38f89536caae13e687ebd33dfc1b85c4d98f27e","locator":"PDF pp1-2: P91-1500 model column, rack/tower configuration and included tower pedestals; 2026-09-11 revision","basis":"manufacturer"}]},"xpc-p91-3000":{"sku":null,"rack":{"role":"separate_chassis","enclosure_handles":[],"u":2.0,"chassis_depth_in":23.8,"depth_role":"own_clearance","installed_depth_in":null},"tower":{"role":"supported"},"source":[{"fact":"rack.role","sha256":"4265f56d398fd9b60ab5b21b9b39cf669f5da38b72ec2000de0a1ccf507ee767","locator":"PDF p15 pack/UPS row and depth footnote","basis":"reviewed_relation"},{"fact":"rack.u","sha256":"4265f56d398fd9b60ab5b21b9b39cf669f5da38b72ec2000de0a1ccf507ee767","locator":"PDF p15 pack/UPS row and depth footnote","basis":"manufacturer"},{"fact":"rack.chassis_depth_in","sha256":"4265f56d398fd9b60ab5b21b9b39cf669f5da38b72ec2000de0a1ccf507ee767","locator":"PDF p15 pack/UPS row and depth footnote","basis":"manufacturer"},{"fact":"rack.depth_role","sha256":"4265f56d398fd9b60ab5b21b9b39cf669f5da38b72ec2000de0a1ccf507ee767","locator":"PDF p15 pack/UPS row and depth footnote","basis":"reviewed_relation"},{"fact":"tower.role","sha256":"fbd68fd39aa90358cac31c23e38f89536caae13e687ebd33dfc1b85c4d98f27e","locator":"PDF pp1-2: P91-3000 rack/tower model, included tower pedestals","basis":"manufacturer"}]},"xpc-p90-bp48":{"sku":null,"rack":{"role":"separate_chassis","enclosure_handles":[],"u":2.0,"chassis_depth_in":18.9,"depth_role":"own_clearance","installed_depth_in":null},"tower":{"role":"supported_with_selected_ups","selected_ups_handles":["xpc-p80-1500"],"max_verified_pack_quantity":1},"source":[{"fact":"rack.role","sha256":"4265f56d398fd9b60ab5b21b9b39cf669f5da38b72ec2000de0a1ccf507ee767","locator":"PDF p6 pack/UPS row and depth footnote","basis":"reviewed_relation"},{"fact":"rack.u","sha256":"4265f56d398fd9b60ab5b21b9b39cf669f5da38b72ec2000de0a1ccf507ee767","locator":"PDF p6 pack/UPS row and depth footnote","basis":"manufacturer"},{"fact":"rack.chassis_depth_in","sha256":"4265f56d398fd9b60ab5b21b9b39cf669f5da38b72ec2000de0a1ccf507ee767","locator":"PDF p6 pack/UPS row and depth footnote","basis":"manufacturer"},{"fact":"rack.depth_role","sha256":"4265f56d398fd9b60ab5b21b9b39cf669f5da38b72ec2000de0a1ccf507ee767","locator":"PDF p6 pack/UPS row and depth footnote","basis":"reviewed_relation"},{"fact":"tower.role","sha256":"a7506b390f8d3b89ef96b50f126524d8c2d57d28d4493188a1ededab2c3226a3","locator":"PDF pp36-38: Appendix A expressly names P90-BP48; p37 pack box includes extended stand and battery connection cable, allows vertical desk placement; p38 illustrates adjacent UPS+pack tower installation","basis":"manufacturer"},{"fact":"tower.selected_ups_handles","sha256":"4265f56d398fd9b60ab5b21b9b39cf669f5da38b72ec2000de0a1ccf507ee767","locator":"PDF p6 P90-BP48 part 90000916 is the 48V pack for P80-1500/P80-2000; this proposal scopes only P80-1500","basis":"manufacturer"},{"fact":"tower.max_verified_pack_quantity","sha256":"a7506b390f8d3b89ef96b50f126524d8c2d57d28d4493188a1ededab2c3226a3","locator":"PDF p38 tower figure explicitly depicts one UPS plus one battery box on extended stand; electrical drawing permits a second pack but does not depict/support a three-unit tower stand","basis":"derived"}]},"xpc-p90-bp72":{"sku":null,"rack":{"role":"separate_chassis","enclosure_handles":[],"u":2.0,"chassis_depth_in":23.6,"depth_role":"own_clearance","installed_depth_in":null},"tower":{"role":"supported_with_selected_ups","selected_ups_handles":["xpc-p80-3000v2"],"max_verified_pack_quantity":1},"source":[{"fact":"rack.role","sha256":"4265f56d398fd9b60ab5b21b9b39cf669f5da38b72ec2000de0a1ccf507ee767","locator":"PDF p6 pack/UPS row and depth footnote","basis":"reviewed_relation"},{"fact":"rack.u","sha256":"4265f56d398fd9b60ab5b21b9b39cf669f5da38b72ec2000de0a1ccf507ee767","locator":"PDF p6 pack/UPS row and depth footnote","basis":"manufacturer"},{"fact":"rack.chassis_depth_in","sha256":"4265f56d398fd9b60ab5b21b9b39cf669f5da38b72ec2000de0a1ccf507ee767","locator":"PDF p6 pack/UPS row and depth footnote","basis":"manufacturer"},{"fact":"rack.depth_role","sha256":"4265f56d398fd9b60ab5b21b9b39cf669f5da38b72ec2000de0a1ccf507ee767","locator":"PDF p6 pack/UPS row and depth footnote","basis":"reviewed_relation"},{"fact":"tower.role","sha256":"a7506b390f8d3b89ef96b50f126524d8c2d57d28d4493188a1ededab2c3226a3","locator":"PDF pp36-38: Appendix A expressly names P90-BP72; p37 pack box includes extended stand and battery connection cable; p38 shows adjacent UPS+one battery box upright on stand","basis":"manufacturer"},{"fact":"tower.selected_ups_handles","sha256":"fc88d01ae63ddc54a7edfc8aba73febfecf051ac0f168a7e757bef41d0a91f72","locator":"PDF p2 P80-3000(V2) model column lists optional P90-BP72; pricebook pp6-7 lists P90-BP72/90000917 and P80-3000(V2) pack limit","basis":"manufacturer"},{"fact":"tower.max_verified_pack_quantity","sha256":"a7506b390f8d3b89ef96b50f126524d8c2d57d28d4493188a1ededab2c3226a3","locator":"PDF p38 tower illustration shows one UPS and one pack; connection diagram permits another pack electrically but does not document three-unit stand support","basis":"derived"}]},"xpc-snmp-2pv3":{"sku":null,"rack":{"role":"inside_selected_enclosure","enclosure_handles":["xpc-p80-1500","xpc-p80-3000v2","xpc-p91-1500","xpc-p91-3000"],"u":null,"chassis_depth_in":null,"depth_role":"covered_by_enclosure","installed_depth_in":null},"tower":{"role":"inside_selected_enclosure","enclosure_handles":["xpc-p80-1500","xpc-p80-3000v2","xpc-p91-1500","xpc-p91-3000"],"max_supported_quantity_per_enclosure":1},"source":[{"fact":"rack.role","sha256":"f6200f090c7ec308243c83a8cb3870f179287b8da18a279f42fd6b6bca5dcd71","locator":"PDF p2 SNMP-2PV3 internal card/module checked; internal power; external box unchecked","basis":"manufacturer"},{"fact":"rack.enclosure_handles","sha256":"90b919a5416290d3fde6de6ff6af9bd676d7d3d1ba924995312809cbc2bf912f","locator":"Four-pair table, exact P80-1500/P80-3000V2/P91-1500/P91-3000 slot evidence; pricebook pp7,16; P80 manual pp6,10; P91 manual pp7,11; P80/P91 flyers p2","basis":"reviewed_relation"},{"fact":"rack.depth_role","sha256":"90b919a5416290d3fde6de6ff6af9bd676d7d3d1ba924995312809cbc2bf912f","locator":"Conclusion: no separate rack U derived from internal card occupying UPS intelligent slot","basis":"derived"},{"fact":"tower.role","sha256":"f6200f090c7ec308243c83a8cb3870f179287b8da18a279f42fd6b6bca5dcd71","locator":"SNMP flyer PDF p2: SNMP-2PV3 internal card/module checked, internal power, external box unchecked; orientation-neutral internal role","basis":"manufacturer"},{"fact":"tower.enclosure_handles","sha256":"90b919a5416290d3fde6de6ff6af9bd676d7d3d1ba924995312809cbc2bf912f","locator":"C16 four-pair table: exact P80-1500/P80-3000V2/P91-1500/P91-3000 intelligent-slot relation; source chain pricebook pp7,16, P80 manual pp6,10, P91 manual pp7,11, 2026 P80/P91 flyers p2","basis":"reviewed_relation"},{"fact":"tower.max_supported_quantity_per_enclosure","sha256":"90b919a5416290d3fde6de6ff6af9bd676d7d3d1ba924995312809cbc2bf912f","locator":"C16 four-pair table and cited single intelligent-slot rear views; one card per evidenced slot; no source for two SNMP-2PV3 cards in one UPS","basis":"derived"}]}};
  function towerPhysicalSourceMatches(index, items) {
    if (!index || index.physical_manifest_sha256 !== TOWER_MANIFEST_SHA || !index.physical) return false;
    return items.every(function (it) {
      var expected = TOWER_PHYSICAL_CONTRACT[it[0]];
      return !!expected && JSON.stringify(index.physical[it[0]]) === JSON.stringify(expected);
    });
  }
  var TOWER_PLACEMENT_MODELS = {
    'xpc-p80-1500': 1, 'xpc-p80-3000v2': 1,
    'xpc-p91-1500': 1, 'xpc-p91-3000': 1
  };
  function towerPlacementContext(e, sel, index, fit) {
    var handle = e.u.h;
    fit = fit || physicalFit(e, sel, { fit: 'tower' }, index);
    if (!TOWER_PLACEMENT_MODELS[handle]) return null;
    if (fit.orientation !== 'tower' || fit.status !== 'pass') return null;
    var items = configure(e, sel).items;
    if (items.length < 1 || items.length > 3 || items[0][0] !== handle || items[0][3] !== 1 ||
        !towerPhysicalSourceMatches(index, items)) return null;
    var packCount = 0, cardCount = 0;
    for (var i = 1; i < items.length; i++) {
      if (items[i][0] === 'xpc-snmp-2pv3' && items[i][3] === 1) cardCount++;
      else if (P80_TOWER_PACK_PAIRS[items[i][0]] === handle && items[i][3] === 1) packCount++;
      else return null;
    }
    if (cardCount > 1 || packCount > 1) return null;
    return { version: TOWER_PLACEMENT_VERSION, manifest: TOWER_MANIFEST_SHA,
      source: TOWER_PHYSICAL_CONTRACT_SHA,
      orientation: 'tower', items: JSON.stringify(items.map(function (it) { return [it[0], it[3]]; })) };
  }
  function towerPlacementAnswer(e, sel, q, index, fit) {
    var context = towerPlacementContext(e, sel, index, fit);
    if (!context) return '';
    var handle = e.u.h;
    var ack = q.towerPlacement && q.towerPlacement[handle];
    if (!ack || ack.version !== context.version || ack.manifest !== context.manifest ||
        ack.source !== context.source ||
        ack.orientation !== context.orientation || ack.items !== context.items ||
        typeof ack.at !== 'string' || !/^\d{4}-\d\d-\d\dT/.test(ack.at)) return '';
    return ['yes', 'no', 'unsure'].indexOf(ack.answer) >= 0 ? ack.answer : '';
  }
  function buyerPhysicalFit(e, sel, q, index) {
    var fit = physicalFit(e, sel, q, index), handle = e.u.h;
    if (!TOWER_PLACEMENT_MODELS[handle]) return fit;
    if (fit.orientation !== 'tower' || fit.status !== 'pass') return fit;
    if (towerPlacementAnswer(e, sel, q, index, fit) === 'yes') return fit;
    fit.status = 'review';
    fit.reasons.push('tower_placement');
    return fit;
  }

  function hasType(u, index, t) { return countType(u, index, t) > 0; }
  function countType(u, index, t) {
    var n = 0, acc = u.acc || [];
    for (var i = 0; i < acc.length; i++) if (eligibleAccessory(index.ac[acc[i]], t, u)) n++;
    return n;
  }

  // Fit class first (R1: a unit that does not meet an input is never promoted): 0 meets the runtime on its own,
  // 1 meets it with a known pack count (C.06 table), 2 takes packs whose count is to confirm, 3 cannot meet it or no
  // runtime data.
  function fitClass(e) { return e.meets ? 0 : (e.need ? 1 : (e.packs > 0 ? 2 : 3)); }

  // Fit steps: a unit that fails an input never moves above one that meets it (R1). 0 = tie on all of them.
  function rankFit(a, b) {
    if (a.mismatch !== b.mismatch) return a.mismatch ? 1 : -1;   // wrong outlet goes last, greyed out
    if ((a.tooBig || 0) !== (b.tooBig || 0)) return (a.tooBig || 0) - (b.tooBig || 0); // chassis taller/deeper than typed
    if (a.plugUnknown !== b.plugUnknown) return a.plugUnknown ? 1 : -1; // outlet named: known fit before unknown plug
    var physicalOrder = { pass: 0, review: 1, mismatch: 2 };
    if (a.physical.status !== b.physical.status) return physicalOrder[a.physical.status] - physicalOrder[b.physical.status];
    var ar = !!((a.meets || a.need) && a.cardReady && !a.p91Capacity),
        br = !!((b.meets || b.need) && b.cardReady && !b.p91Capacity);
    if (ar !== br) return ar ? -1 : 1;                           // runtime and requested network card are evidenced
    if (a.confirm !== b.confirm) return a.confirm - b.confirm;     // known electrical and installation facts first
    var ga = Math.max(1, fitClass(a)), gb = Math.max(1, fitClass(b));
    if (ga !== gb) return ga - gb;                                // meets the runtime (alone or with known packs) first
    // E.16: a unit running under 25 % of its rating (4x oversized) goes after every right-sized unit
    // (buyer test 1: a 1,450 W unit led a 350 W closet at $3,569.74).
    var ao = a.loadPct < 0.25 ? 1 : 0, bo = b.loadPct < 0.25 ? 1 : 0;
    if (ao !== bo) return ao - bo;
    if ((a.disc || 0) !== (b.disc || 0)) return (a.disc || 0) - (b.disc || 0); // current models before discontinued ones
    return 0;
  }

  // Detail steps inside the same order group.
  function rankDetail(a, b) {
    // Builder UX pass (09-30): outlet not chosen yet: a unit on a standard wall plug before one that needs a twist-lock
    // outlet or an electrician.
    if ((a.plugPref || 0) !== (b.plugPref || 0)) return (a.plugPref || 0) - (b.plugPref || 0);
    var fa = fitClass(a), fb = fitClass(b);
    if (fa !== fb) return fa - fb;
    if (a.priced !== b.priced) return a.priced ? -1 : 1;          // complete known price before quote-only
    return 0;
  }

  // Last: in-band load, then the configured total (Grok review, 2 Oct 2026: not the bare UPS).
  function rankLast(a, b) {
    var ab = (a.loadPct >= 0.5 && a.loadPct <= 0.85) ? 0 : (a.loadPct < 0.25 ? 2 : 1);
    var bb = (b.loadPct >= 0.5 && b.loadPct <= 0.85) ? 0 : (b.loadPct < 0.25 ? 2 : 1);
    if (ab !== bb) return ab - bb;                                 // in-band load first
    var ap = a.cfgTotal || 1e12, bp = b.cfgTotal || 1e12;
    if (ap !== bp) return ap - bp;
    return (a.u.p || 1e12) - (b.u.p || 1e12);
  }

  function rank(a, b) {
    var r = rankFit(a, b);
    if (r) return r;
    if (a.ord !== b.ord) return a.ord - b.ord;
    return rankDetail(a, b) || rankLast(a, b);
  }

  // 0 = the plug most wall outlets of that supply take, 1 = the 20 A version, 2 = twist-lock, hardwired or unknown.
  function plugPreference(plug, power) {
    var p = String(plug || '').toUpperCase();
    if (power === '208-240') return /L6-20P/.test(p) ? 0 : (/L6-30P/.test(p) ? 1 : 2);
    if (power !== '120' && power !== 'unknown') return 0;
    return /(^|[^L])5-15P/.test(p) ? 0 : (/(^|[^L])5-20P/.test(p) ? 1 : 2);
  }

  // Builder UX pass (09-30, round 3): with "Rack" and a typed rack space or depth, a UPS whose own chassis is taller
  // (store rack units, ru_src 'm') or deeper (store depth + 0.25 in) than that space cannot fit, whatever packs are
  // added. It only ever marks a unit as not fitting; the verified physical check still decides every fit.
  function rackTooBig(u, q) {
    if (q.fit !== 'rack' || (u.ff !== 'R' && u.ff !== 'C')) return 0;
    if (q.rackU && u.ru_src === 'm' && typeof u.ru === 'number' && u.ru > q.rackU) return 1;
    if (q.depth && typeof u.dp === 'number' && u.dp > q.depth + 0.25) return 1;
    return 0;
  }

  function solve(index, q, selections, qualify) {
    var list = rows(index), res = [];
    for (var i = 0; i < list.length; i++) {
      var e = evaluate(list[i], q, index);
      if (e) {
        e.plugPref = q.outlet === 'unknown' ? plugPreference(e.u.plug, q.power) : 0;
        e.disc = e.u.lc === 'D' ? 1 : 0;
        e.tooBig = rackTooBig(e.u, q);
        if (selections && selections[e.u.h]) {
          var selected = selections[e.u.h];
          e.physical = buyerPhysicalFit(e, selected, q, index);
          if (e.u.card === '' && selected.c >= 0 && e.opts.c[selected.c]) {
            e.cardReady = false;
            if (!q.card) e.confirm++;
          }
        }
        if (typeof qualify === 'function') e = qualify(e, q); // capacity review before ranking
        res.push(e);
      }
    }
    res.sort(rank);
    return res;
  }

  window.UPSBBuilder = { fitClass: fitClass, solve: solve, configure: configure, physicalFit: physicalFit,
    buyerPhysicalFit: buyerPhysicalFit, towerPlacementContext: towerPlacementContext,
    towerPlacementAnswer: towerPlacementAnswer, MAX_PACKS: MAX_PACKS, tableAt: tableAt,
    packRuntime: packRuntime, runtimeAt: runtimeAt, plugFits: plugFits, voltFits: voltFits,
    typedInputDecision: typedInputDecision, j60Decision: j60Decision,
    bundleRuntimeReference: bundleRuntimeReference, validOutputConnections: validOutputConnections, rows: rows,
    rackTooBig: rackTooBig, listOf: listOf };
})();
